import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b0af3ab6"
import script from "./availedItcDtls.js?vue&type=script&lang=js&external"
export * from "./availedItcDtls.js?vue&type=script&lang=js&external"
import style0 from "./availedItcDtls.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports